import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import { Table, Tbody, Tr, Td, Th, TableContainer, Box, Text } from '@chakra-ui/react';
import { useParams } from 'react-router-dom';

const Print_Pdf_Tr = forwardRef(({ staffData, userId }, ref) => {
  const { user_id } = useParams();
  const printRef = useRef();

  useImperativeHandle(ref, () => ({
    handlePrint,
  }));

  const handlePrint = () => {
    const content = printRef.current.innerHTML;
    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "none";
    document.body.appendChild(iframe);

    const iframeDoc = iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(`<div>${content}</div>`);
    iframeDoc.close();

    const images = iframeDoc.getElementsByTagName("img");
    const loadPromises = Array.from(images).map((img) =>
      new Promise((resolve) => {
        img.onload = resolve;
        img.onerror = resolve;
      })
    );

    Promise.all(loadPromises).then(() => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      document.body.removeChild(iframe);
    });
  };

  const basicInfo = [
    { label: "Name", value: staffData.name },
    { label: "Email ID", value: staffData.email },
    { label: "Gender", value: staffData.gender },
    { label: "Date of Birth", value: staffData.date_of_birth },
    { label: "Date of Joining", value: staffData.date_of_join },
    { label: "Nation", value: staffData.nation },
    { label: "State", value: staffData.state },
    { label: "District", value: staffData.district },
    { label: "Place", value: staffData.place },
    { label: "Blood Group", value: staffData.group },
    { label: "Aadhar Number", value: staffData.aadhar_no },
  ];

  const homeAddress = [
    { label: "Address", value: staffData.address },
    { label: "Mobile No", value: staffData.contact_no },
  ];

  const parentDetails = [
    { label: "Guardian's Name", value: staffData.guardian_name },
    { label: "Guardian's Relation", value: staffData.relation },
    { label: "Guardian's Address", value: staffData.guardian_address },
    { label: "Guardian's Contact", value: staffData.guardian_contact_no },
  ];

  return (
    <div>
      <div ref={printRef} style={{ padding: '20px', fontFamily: 'Arial, sans-serif', lineHeight: '1.5' }}>
        {/* Header with Logo */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "40px",
            borderBottom: "2px solid #000",
            paddingBottom: "20px",
            textAlign: "center",
          }}
        >
          <img
            src="https://www.vimalagiriinternational.com/static/media/logo-removebg-preview%20(1).1b7b766c8c63e51dbc52.png"
            alt="Vimalagiri Logo"
            style={{ width: "180px", height: "auto", marginBottom: "10px" }}
            onError={() => console.error("Error loading logo image")}
          />
          <div>
            <h1 style={{ margin: "0", fontSize: "72px", fontWeight: "bold", lineHeight: "0.7", fontFamily: "'Times New Roman', serif" }}>
              Vimalagiri
            </h1>
            <h2 style={{ margin: "0", fontSize: "28px", fontWeight: "bold", marginTop: "10px", fontFamily: "'Times New Roman', serif" }}>
              International School
            </h2>
            <Text style={{ fontSize: "16px", color: "#777", marginTop: "10px" }}>
              Affiliated to CISCE New Delhi Aff.No.KE143
            </Text>
          </div>
        </div>

        {/* Basic Information Section */}
        <div style={{ marginBottom: '40px' }}>
          <h2>Basic Information</h2>
          <Table  sx={{
                "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
              }} size="sm" border="1px solid #d4c2c2" style={{ borderCollapse: 'collapse', width: '100%' }}>
            <Tbody>
              {basicInfo.map((info) => (
                <Tr key={info.label}>
                  <Td style={{ border: '1px solid #d4c2c2', padding: '8px', fontWeight: 'bold' }}>{info.label}</Td>
                  <Td style={{ border: '1px solid #d4c2c2', padding: '8px' }}>{info.value || "N/A"}</Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </div>

        {/* Home Address Section */}
        <div style={{ marginBottom: '40px' }}>
          <h2>Home Address</h2>
          <Table  sx={{
                "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
              }} size="sm" border="1px solid #d4c2c2" style={{ borderCollapse: 'collapse', width: '100%' }}>
            <Tbody>
              {homeAddress.map((info) => (
                <Tr key={info.label}>
                  <Td style={{ border: '1px solid #d4c2c2', padding: '8px', fontWeight: 'bold' }}>{info.label}</Td>
                  <Td style={{ border: '1px solid #d4c2c2', padding: '8px' }}>{info.value || "N/A"}</Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </div>

        {/* Guardian Details Section */}
        <div style={{ marginBottom: '40px' }}>
          <h2>Guardian Details</h2>
          <Table  sx={{
                "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
              }} size="sm" border="1px solid #d4c2c2" style={{ borderCollapse: 'collapse', width: '100%' }}>
            <Tbody>
              {parentDetails.map((info) => (
                <Tr key={info.label}>
                  <Td style={{ border: '1px solid #d4c2c2', padding: '8px', fontWeight: 'bold' }}>{info.label}</Td>
                  <Td style={{ border: '1px solid #d4c2c2', padding: '8px' }}>{info.value || "N/A"}</Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </div>
      </div>
    </div>
  );
});

export default Print_Pdf_Tr;
